import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { OnboardingStatusService } from '@self-serve/services/onboarding-status.service';
import { NavGroup } from '../../components/side-nav/side-nav.component';
import { OnboardingStatus } from '../../services/types';

@Component({
    templateUrl: './book-a-call.template.html',
    styleUrls: ['../../self-serve.style.scss'],
})
export class BookACallView {
    navGroups: NavGroup[] = [];

    private onboardingStatus: OnboardingStatus | null = null;

    constructor(private onboardingStatusService: OnboardingStatusService) {
        this.setNavGroups();

        this.onboardingStatusService.onboardingStatus$.pipe(takeUntilDestroyed()).subscribe((onboardingStatus) => {
            this.onboardingStatus = onboardingStatus;
            this.setNavGroups();
        });
    }

    private setNavGroups(): void {
        const navGroups: NavGroup[] = [
            {
                title: 'self-serve.bookACall.bookACall',
                steps: [
                    {
                        text: 'self-serve.bookACall.sideNav.reviewPlanAndBookCall',
                        href: 'review',
                        complete: this.onboardingStatus?.bookACall.steps.reviewPlanAndBookCall ?? false,
                    },
                ],
            },
        ];

        this.navGroups = navGroups;
    }
}
